export const searchDepartments = (searchQuery, tableRows) => {
  const result = tableRows.filter(row => {
    const checkCondition = (item) => {
      return item.toString().toLowerCase().includes(searchQuery.toLowerCase())
    };
    const checkType = (item) => {
      return typeof item === 'string' || typeof item === 'number'
    };

    return Object.values(row).some(val => {
      let message = false;
      if (checkType(val)) {
        message = checkCondition(val);
      } else if (val !== null && val.props && val.props.array) {
        val.props.array.map(value => {
          if (val.props.nameProp) {
            if(checkType(value[val.props.nameProp]) && checkCondition(value[val.props.nameProp])){
              message = true;
            }
          } else if(checkType(value) && checkCondition(value)){
            message = true;
          }
        })
      }
      return message;
    })
  })
  return result;
}